import React from 'react';

import { Box, Typography } from 'components';

import { useTranslation } from 'third-party';

export const TermsCondition = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <>
        <Box
          sx={{
            width: '100%',
            position: 'relative',
            paddingBottom: '0.3rem',
          }}
        >
          <Typography
            variant="h2"
            sx={{
              textAlign: 'center',
              width: '100%',
            }}
          >
            {t('legal.termsCondition.header')}
          </Typography>
        </Box>

        <Box sx={{ paddingBottom: '1rem', textAlign: 'center' }}>
          <Typography variant="subtitle1" sx={{ paddingTop: '0.8rem' }}>
            {t('legal.termsCondition.subHeader')}
          </Typography>
        </Box>

        <Box
          sx={{
            margin: '0 auto',
            padding: '1rem',
            maxHeight: '70vh',
            overflow: 'auto',
          }}
        >
          <Typography variant="body2" paragraph>
            <strong>Last Updated: July 15, 2025</strong>
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            AGREEMENT TO TERMS
          </Typography>
          <Typography variant="body2" paragraph>
            These Terms of Use ("Terms") constitute a legally binding agreement
            between you ("you", "user") and EasyECheck.online ("Company", "we",
            "our", "us"), governing your access to and use of the
            EasyECheck.online website (the "Site"). EasyECheck.online is a
            financial technology platform that provides the service of issuing
            and emailing electronic checks ("eChecks") that can be printed and
            deposited as regular checks. We do not provide any banking services
            or act as a bank.
          </Typography>
          <Typography variant="body2" paragraph>
            By using our Site, you agree to be bound by these Terms. If you do
            not agree, you may not use the Site.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            DISCLOSURE
          </Typography>
          <Typography variant="body2" paragraph>
            The services offered through EasyECheck.online are limited to the
            creation and electronic delivery of printable eChecks. We are not a
            bank. The eChecks you send are not covered by FDIC insurance and
            must be deposited through regular banking channels.
          </Typography>
          <Typography variant="body2" paragraph>
            All content provided on the Site is for general information purposes
            only. We do not guarantee the accuracy, completeness, or usefulness
            of this information. Your use of the Site and reliance on any
            information is at your sole risk.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            INTELLECTUAL PROPERTY
          </Typography>
          <Typography variant="body2" paragraph>
            All source code, design, content, logos, and trademarks on the Site
            are the intellectual property of EasyECheck.online unless otherwise
            stated. You are granted a limited, non-transferable, non-exclusive
            license to use the Site for personal or business use related to
            eCheck issuance only.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            USER REPRESENTATIONS
          </Typography>
          <Typography variant="body2" paragraph>
            By using the Site, you represent that:
          </Typography>
          <Typography variant="body2" component="div" sx={{ pl: 2 }}>
            <ul>
              <li>You are at least 18 years of age.</li>
              <li>All registration information you provide is accurate.</li>
              <li>
                You will use the Site lawfully and in accordance with these
                Terms.
              </li>
            </ul>
          </Typography>
          <Typography variant="body2" paragraph>
            We reserve the right to suspend or terminate your access if we
            believe you are violating any part of these Terms.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            SERVICE LIMITATION
          </Typography>
          <Typography variant="body2" paragraph>
            Our service is limited to the creation, generation, and electronic
            delivery of eChecks. We do not manage bank transfers, account
            verifications, or check deposits. The user is solely responsible for
            ensuring that any generated eCheck is legally valid, accurate, and
            sent to the intended recipient.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            FEES AND PAYMENTS
          </Typography>
          <Typography variant="body2" paragraph>
            You agree to pay all applicable fees according to your selected
            plan. All transactions are final. No refunds are issued for
            generated eChecks or subscription usage unless explicitly stated in
            a separate agreement.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            PROHIBITED USES
          </Typography>
          <Typography variant="body2" paragraph>
            You may not use the Site to:
          </Typography>
          <Typography variant="body2" component="div" sx={{ pl: 2 }}>
            <ul>
              <li>
                Commit fraud or issue checks on accounts you are not authorized
                to use.
              </li>
              <li>Harass, harm, or mislead others.</li>
              <li>Circumvent security features.</li>
              <li>Interfere with system operations or abuse our platform.</li>
            </ul>
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            ACCOUNT REGISTRATION
          </Typography>
          <Typography variant="body2" paragraph>
            You may be required to register for an account. You agree to keep
            your login credentials secure and not share access with others. We
            reserve the right to delete or reclaim usernames that we determine
            inappropriate or inactive.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            PRIVACY
          </Typography>
          <Typography variant="body2" paragraph>
            Please refer to our Privacy Policy to understand how we collect and
            use your data. By using our Site, you consent to data practices as
            described in the Privacy Policy.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            DISCLAIMER
          </Typography>
          <Typography variant="body2" paragraph>
            The Site is provided "as-is." We make no warranties or
            representations about the Site's accuracy, functionality,
            availability, or fitness for any particular purpose.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            LIMITATION OF LIABILITY
          </Typography>
          <Typography variant="body2" paragraph>
            To the fullest extent permitted by law, we are not liable for any
            indirect, incidental, special, or consequential damages, including
            loss of data or profits, resulting from your use of the Site.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            INDEMNIFICATION
          </Typography>
          <Typography variant="body2" paragraph>
            You agree to indemnify and hold us harmless against any claims,
            liabilities, damages, or expenses (including legal fees) arising out
            of your use of the Site or violation of these Terms.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            MODIFICATIONS AND TERMINATION
          </Typography>
          <Typography variant="body2" paragraph>
            We reserve the right to modify these Terms at any time. Continued
            use of the Site after changes means you accept the updated Terms. We
            may suspend or terminate your access at our discretion.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            GOVERNING LAW
          </Typography>
          <Typography variant="body2" paragraph>
            These Terms are governed by the laws of the Commonwealth of
            Pennsylvania, without regard to conflict of laws principles.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            CONTACT
          </Typography>
          <Typography variant="body2" paragraph>
            For questions or concerns, contact us at support@easyecheck.online
          </Typography>
        </Box>
      </>
    </Box>
  );
};
